import { parseToEnum } from '../../../../util/parseToEnum';
import { CountryState, Metro, STATE_PER_METRO } from '../../constants';
import { FilterChoice } from '../../types/FilterChoice';
import { SuburbChoice } from '../../types/LocationChoice';
import { PathMaker } from '../../types/PathParser';
import { hyphenDecode, hyphenEncode, toSentenceCase } from './util';

const ENDS_WITH_POSTCODE = /.+-\d{4}$/;

export const makeLocationSegment: PathMaker = function* ({ location }) {
  if (!location) {
    yield 'Australia';
  } else if (location.state) {
    yield location.state;
  } else if (location.metro) {
    yield STATE_PER_METRO[location.metro];
    yield location.metro;
  } else if (location.suburb) {
    yield* encodeSuburb(location);
  }
};

export const parseState = (token: string, filters: FilterChoice) => {
  const tokenAsState = parseToEnum(token.toUpperCase(), CountryState);
  if (!tokenAsState) return false;
  filters.location = { state: tokenAsState };
  return true;
};

export const parseMetro = (token: string, filters: FilterChoice) => {
  const tokenAsMetro = parseToEnum(toSentenceCase(token), Metro);
  if (!tokenAsMetro) return false;
  filters.location = { metro: tokenAsMetro };
  return true;
};

export const parseSuburb = (token: string, filters: FilterChoice) => {
  /** A suburb must be preceded (directly or indirectly) by either a state or a specialty.
   * Otherwise, a suburb-like token MAY be a specialty (eg `flu-vaccination-2021`),
   * so we assume it is not a suburb. */
  if (!filters.location?.state && !filters.topic) return false;

  const decodedSuburb = decodeSuburb(token, filters.location?.state);
  if (!decodedSuburb) return false;
  filters.location = decodedSuburb;
  return true;
};

const encodeSuburb = ({ suburb }: SuburbChoice) => {
  const { state, name, postcode } = suburb;
  const suburbSegment = `${hyphenEncode(toSentenceCase(name ?? ''))}-${postcode}`;
  return state ? [state, suburbSegment] : [suburbSegment];
};

export const decodeSuburb = (
  token: string,
  state: CountryState | undefined,
): SuburbChoice | null => {
  if (ENDS_WITH_POSTCODE.test(token)) {
    const parts = hyphenDecode(token).split(' ');
    return {
      suburb: {
        state,
        postcode: parts.slice(-1)[0],
        name: toSentenceCase(parts.slice(0, -1).join(' ')),
      },
    };
  } else {
    return null;
  }
};
